
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';

@Component({
  components: {
    CommonBlockLine,
  },
})
export default class ReportClass extends Vue {
  @Prop() private config;
  @Prop() private slide;
  @Prop() private activeTabIndex;

  popupStatus = false;
  showIcon = true;

  get showPopup() {
    return this.config.isShow && this.config.isPopup && this.popupStatus;
  }

  get isInReportOne() {
    const DEHY_REPORT_INDEX = 0;
    return this.slide && this.activeTabIndex === DEHY_REPORT_INDEX;
  }

  get showFloat() {
    return this.config.isShow && !this.config.isPopup && !this.isInReportOne;
  }

  @Watch('config')
  onConfigChanged(config) {
    if (!config.isShow) {
      return;
    }
    if (!config.isPopup) {
      this.listenTouch();
    } else {
      const configKey = `yb_popup_${window.getUserid()}`;
      const enterTime = window.localStorage.getItem(configKey);
      const DAY = 86400000;
      // 当天是否有弹出
      if (!enterTime || Date.now() - Number(enterTime) > DAY) {
        this.popupStatus = true;
        window.localStorage.setItem(configKey, String(Date.now()));
      }
    }
  }
  action() {
    this.popupStatus = false;
    // 跳转到更多
    this.$emit('action', this.config);
  }
  listenTouch() {
    const OUTTIME = 1500;
    let scrollTimer = null;
    addEventListener('scroll', () => {
      this.showIcon = false;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        this.showIcon = true;
      }, OUTTIME);
    });
  }
}
